import css from 'styled-jsx/css';
import { colors, fonts } from 'components/styles/variables';

export default css`
  .field {
    position: relative;
    width: 100%;
  }

  .validation-icon,
  .locked-icon {
    position: absolute;
    right: 14px;
    top: 14px;
  }

  .padding .validation-icon {
    right: 30px;
  }

  .padding .locked-icon {
    right: 34px;
  }

  label.field-label {
    font-size: 18px;
    font-weight: 400;
    color: ${colors.G3};
    transition: top 0.25s;
    position: absolute;
    z-index: 1;
    top: 10px;
    left: 16px;
    cursor: text;
  }

  .padding label.field-label {
    left: 32px;
  }

  label.error-label {
    color: ${colors.ALR1};
    font-size: 12px;
    position: absolute;
    right: 0;
    bottom: -23px;
  }

  .padding label.error-label {
    right: 16px;
  }

  input {
    width: 100%;
    height: 48px;
    padding: 10px 16px;
    box-sizing: border-box;
    background: transparent;
    border-radius: 4px;
    border: 1px solid ${colors.G2};
    font-size: 18px;
    color: ${colors.BLACK};
    caret-color: ${colors.ALR1};
    font-family: ${fonts.default};
    font-weight: 400;
    z-index: 3;
    -webkit-appearance: none;
  }

  .locked input {
    -webkit-text-fill-color: ${colors.G3};
    opacity: 1;
    color: ${colors.G3};
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
  }

  input:valid {
    border: 1px solid ${colors.G2};
  }

  input:focus {
    outline: 0;
    border: 2px solid ${colors.BLACK};
  }

  input:focus + label,
  input:not([value='']) + label {
    top: -13px;
    left: 16px;
    z-index: 0;
    padding: 0px 4px;
    color: ${colors.BLACK};
    background: ${colors.WHITE};
    font-weight: 400;
    font-size: 16px;
  }

  .locked input:focus + label,
  .locked input:not([value='']) + label {
    color: ${colors.G3};
  }

  input.validation-error {
    border-color: ${colors.ALR1};
  }

  input:disabled + label {
    z-index: 0;
    top: -13px;
    left: 16px;
    padding: 0px 4px;
    background: ${colors.WHITE};
    font-weight: 400;
    font-size: 16px;
  }

  .padding {
    padding: 0px 16px;
  }
`;
